"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStatusOK = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel["Error"] = "ERROR";
    LogLevel["Warning"] = "WARNING";
    LogLevel["Info"] = "INFO";
    LogLevel["Debug"] = "DEBUG";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
const isStatusOK = (x) => (x === null || x === void 0 ? void 0 : x.status) === 'OK';
exports.isStatusOK = isStatusOK;
